/* ==========================================================================
   MOGULS FAMILY — Comportamiento propio
   --------------------------------------------------------------------------
   Sin librerías externas. Un archivo para toda la tienda: cada función
   comprueba primero si su elemento existe, así se puede cargar en cualquier
   página sin dar errores.
   ========================================================================== */

(function () {
  'use strict';

  /* ¿El visitante pidió menos movimiento en su sistema? Lo respetamos. */
  var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------------
     Animaciones de entrada
     Añade la clase .mf-visible a los elementos .mf-reveal cuando aparecen
     en pantalla. El efecto en sí lo hace el CSS.
     ------------------------------------------------------------------------ */
  function mostrarTodo() {
    document.querySelectorAll('.mf-reveal:not(.mf-visible)').forEach(function (el) {
      el.classList.add('mf-visible');
    });
  }

  function initReveals() {
    /* Esta clase es la que autoriza al CSS a esconder el contenido para
       animarlo. Si este archivo no llegara a ejecutarse, nunca se pone y la
       tienda se ve entera. Ver la nota en mf-styles.css. */
    document.documentElement.classList.add('mf-js');

    var elementos = document.querySelectorAll('.mf-reveal:not(.mf-visible)');
    if (!elementos.length) return;

    /* Sin soporte o sin movimiento: se muestran directamente */
    if (menosMovimiento || !('IntersectionObserver' in window)) {
      mostrarTodo();
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          entrada.target.classList.add('mf-visible');
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });

    /* Red de seguridad: si por lo que sea el vigilante no llega a avisar
       (pestaña en segundo plano al cargar, navegadores raros...), a los 2
       segundos se muestra todo igualmente. Más vale perder la animación que
       dejar la tienda en blanco. */
    setTimeout(mostrarTodo, 2000);
  }

  /* ------------------------------------------------------------------------
     Barra de anuncios rotativa
     Cambia de frase cada X segundos. La velocidad y el encendido/apagado
     se controlan desde el editor de Shopify (llegan como data-*).
     ------------------------------------------------------------------------ */
  function initAnuncios() {
    var barras = document.querySelectorAll('[data-mf-anuncios]');
    if (!barras.length) return;

    barras.forEach(function (barra) {
      var items = barra.querySelectorAll('.mf-anuncios__item');
      if (items.length < 2) return;

      var autoRotar = barra.dataset.autoRotar === 'true';
      if (!autoRotar || menosMovimiento) return;

      var segundos = parseFloat(barra.dataset.velocidad) || 5;
      var actual = 0;
      var temporizador = null;

      function mostrar(indice) {
        items.forEach(function (item, i) {
          item.classList.toggle('mf-activo', i === indice);
          /* Lo oculto no debe leerlo un lector de pantalla */
          item.setAttribute('aria-hidden', i === indice ? 'false' : 'true');
        });
      }

      function arrancar() {
        detener();
        temporizador = setInterval(function () {
          actual = (actual + 1) % items.length;
          mostrar(actual);
        }, segundos * 1000);
      }

      function detener() {
        if (temporizador) clearInterval(temporizador);
        temporizador = null;
      }

      mostrar(0);
      arrancar();

      /* Cortesía: se pausa al pasar el ratón o al enfocar con el teclado,
         y cuando la pestaña no está a la vista (ahorra batería en móvil). */
      barra.addEventListener('mouseenter', detener);
      barra.addEventListener('mouseleave', arrancar);
      barra.addEventListener('focusin', detener);
      barra.addEventListener('focusout', arrancar);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          detener();
        } else {
          arrancar();
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     Página de producto
     Une tres cosas: la galería, el selector de color/talla y el enlace de
     WhatsApp, que se rearma cada vez que el cliente cambia de opción.
     ------------------------------------------------------------------------ */
  function initProducto() {
    var raiz = document.querySelector('[data-mf-producto]');
    if (!raiz) return;

    var datos = raiz.querySelector('[data-mf-variantes]');
    var variantes = [];
    if (datos) {
      try {
        variantes = JSON.parse(datos.textContent);
      } catch (e) {
        variantes = [];
      }
    }

    /* ---- Galería ---- */
    var pista = raiz.querySelector('[data-mf-pista]');
    var fotos = raiz.querySelectorAll('.mf-pp__foto');
    var minis = raiz.querySelectorAll('.mf-pp__mini');
    var contador = raiz.querySelector('[data-mf-contador-actual]');

    function irAFoto(indice) {
      if (!pista || !fotos[indice]) return;
      /* Se calcula la posición a partir del ancho de la pista, no con
         offsetLeft: cada foto ocupa exactamente el 100%, y offsetLeft se mide
         contra el elemento posicionado de arriba, lo que da sorpresas. */
      pista.scrollTo({
        left: indice * pista.clientWidth,
        behavior: menosMovimiento ? 'auto' : 'smooth'
      });
    }

    function marcarFoto(indice) {
      if (contador) contador.textContent = indice + 1;
      minis.forEach(function (m, i) {
        m.classList.toggle('mf-activa', i === indice);
        m.setAttribute('aria-current', i === indice ? 'true' : 'false');
      });
    }

    minis.forEach(function (mini, i) {
      mini.addEventListener('click', function () {
        irAFoto(i);
        marcarFoto(i);
      });
    });

    /* Al deslizar con el dedo, el contador y las miniaturas siguen la foto.
       Se espera a que el scroll pare para no recalcular en cada píxel. */
    if (pista) {
      var esperando = null;
      pista.addEventListener(
        'scroll',
        function () {
          if (esperando) clearTimeout(esperando);
          esperando = setTimeout(function () {
            var indice = Math.round(pista.scrollLeft / pista.clientWidth);
            marcarFoto(Math.max(0, Math.min(indice, fotos.length - 1)));
          }, 90);
        },
        { passive: true }
      );
    }

    /* ---- Selector de opciones ---- */
    var pastillas = raiz.querySelectorAll('[data-mf-valor]');
    var elegidas = [];

    /* Punto de partida: lo que venga marcado desde el servidor */
    raiz.querySelectorAll('.mf-pp__opcion').forEach(function (grupo) {
      var activa = grupo.querySelector('.mf-pp__pastilla.mf-activa');
      var pos = activa ? parseInt(activa.dataset.mfPos, 10) : 0;
      if (activa && pos) elegidas[pos - 1] = activa.dataset.mfValor;
    });

    function varianteElegida() {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var coincide = true;
        for (var j = 0; j < elegidas.length; j++) {
          if (elegidas[j] !== undefined && v.opciones[j] !== elegidas[j]) {
            coincide = false;
            break;
          }
        }
        if (coincide) return v;
      }
      return null;
    }

    function textoOpciones() {
      return elegidas.filter(Boolean).join(' / ');
    }

    function enlaceWhatsapp(v) {
      var numero = raiz.dataset.whatsapp;
      if (!numero) return null;
      var plantilla = raiz.dataset.plantillaMensaje || '';
      var opciones = textoOpciones();
      var mensaje = plantilla
        .replace('[producto]', raiz.dataset.titulo || '')
        .replace('[opciones]', opciones || 'la opción que me recomiende');
      /* Enlace directo al producto y a la variante, para que sepamos
         exactamente qué está pidiendo el cliente. */
      var url = window.location.origin + (raiz.dataset.urlProducto || '');
      if (v && v.id) url += '?variant=' + v.id;
      mensaje += '\n' + url;
      return 'https://wa.me/' + numero + '?text=' + encodeURIComponent(mensaje);
    }

    function refrescar() {
      actualizar(varianteElegida());
    }

    function actualizar(v) {
      /* Precio y precio tachado — pueden aparecer dos veces (columna y barra) */
      raiz.querySelectorAll('[data-mf-precio]').forEach(function (el) {
        if (v && v.precio) el.textContent = v.precio;
      });
      raiz.querySelectorAll('[data-mf-precio-antes]').forEach(function (el) {
        if (v && v.antes) {
          el.textContent = v.antes;
          el.classList.remove('mf-oculto');
        } else {
          el.classList.add('mf-oculto');
        }
      });

      /* Nombre de la opción elegida junto a su título */
      raiz.querySelectorAll('[data-mf-opcion-valor]').forEach(function (el) {
        var pos = parseInt(el.dataset.mfOpcionValor, 10);
        if (elegidas[pos - 1]) el.textContent = elegidas[pos - 1];
      });

      /* Aviso de pocas existencias */
      var urgencia = raiz.querySelector('[data-mf-urgencia]');
      if (urgencia) {
        var umbral = parseInt(urgencia.dataset.umbral, 10) || 10;
        var pocas = v && v.gestion && v.existencias > 0 && v.existencias <= umbral;
        urgencia.classList.toggle('mf-oculto', !pocas);
        if (pocas) {
          var salida = urgencia.querySelector('[data-mf-urgencia-texto]');
          if (salida) {
            salida.textContent = (urgencia.dataset.plantilla || '').replace('[cantidad]', v.existencias);
          }
        }
      }

      /* Variante para las apps de contra entrega */
      var campo = raiz.querySelector('[data-mf-variante-id]');
      if (campo && v) campo.value = v.id;

      /* Foto asociada a la variante (p. ej. al cambiar de color) */
      if (v && v.media_id) {
        for (var i = 0; i < fotos.length; i++) {
          if (parseInt(fotos[i].dataset.mediaId, 10) === v.media_id) {
            irAFoto(i);
            marcarFoto(i);
            break;
          }
        }
      }

      /* Enlace de WhatsApp, con producto y opciones ya escritos */
      var enlace = enlaceWhatsapp(v);
      raiz.querySelectorAll('[data-mf-wa]').forEach(function (a) {
        if (enlace) a.setAttribute('href', enlace);
      });

      /* Dirección de la página, para que se pueda compartir la variante */
      if (v && window.history && window.history.replaceState) {
        var nueva = new URL(window.location.href);
        nueva.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', nueva);
      }

      /* Agotado */
      raiz.querySelectorAll('[data-mf-wa]').forEach(function (a) {
        a.classList.toggle('mf-btn--agotado', !!(v && v.disponible === false));
      });
    }

    pastillas.forEach(function (p) {
      p.addEventListener('click', function () {
        var pos = parseInt(p.dataset.mfPos, 10);
        elegidas[pos - 1] = p.dataset.mfValor;

        /* Solo se desmarcan las pastillas del mismo grupo */
        var grupo = p.closest('.mf-pp__pastillas');
        if (grupo) {
          grupo.querySelectorAll('.mf-pp__pastilla').forEach(function (o) {
            o.classList.toggle('mf-activa', o === p);
          });
        }

        refrescar();
      });
    });

    /* Primera pasada, para que el enlace de WhatsApp ya salga armado */
    refrescar();
  }

  /* ------------------------------------------------------------------------
     Arranque
     ------------------------------------------------------------------------ */
  function iniciar() {
    initReveals();
    initAnuncios();
    initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }

  /* El editor de Shopify recarga secciones sueltas sin refrescar la página:
     hay que volver a enganchar el comportamiento cuando eso pasa. */
  document.addEventListener('shopify:section:load', iniciar);
  document.addEventListener('shopify:section:unload', iniciar);
})();
